import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import { Link } from "@mui/material";
import {
  DataGrid,
  GridColumnSettings,
  PageHeader,
  Spacer,
  previewFile,
  timestampValueGetter,
} from "common";
import I18n from "i18n-js";
import useAccess from "../profile/useAccess";
import useSubmitList from "./useSubmitList";
export interface SubmitListProps {
  showHeader?: boolean;
  waiver_id?: any;
}
export default function SubmitList({ showHeader, waiver_id }: SubmitListProps) {
  const { grid, submitLimit, submitCount } = useSubmitList({ waiver_id });
  const access = useAccess();
  let columnSettings: GridColumnSettings = {
    created_at: { valueFormatter: timestampValueGetter },
    file: {
      renderCell: ({ row, value }) => {
        return (
          <Link
            href={value?.url}
            onClick={(evt: any) => {
              evt.preventDefault();
              if (value?.url && value?.url !== "") {
                previewFile({
                  url: value?.url,
                  title: value?.file_name,
                  fileName: row.value?.file_name,
                });
              }
            }}
          >
            {!!value?.url && value?.url !== "" ? value?.file_name : ""}
          </Link>
        );
      },
    },
  };

  return (
    <>
      {showHeader !== false && (
        <>
          <PageHeader
            avatar={<AssignmentTurnedInIcon />}
            title={I18n.t("Submit.title")}
            sx={{ mt: -3 }}
          />
          <Spacer h={2} />
        </>
      )}
      <DataGrid
        {...grid}
        modalProps={{
          maxWidth: "md",
        }}
        columnSettings={columnSettings}
        headerItems={["search", "refresh"]}
        canDelete={false}
        canView={false}
      />
    </>
  );
}
